// import { create } from 'core-js/core/object';
import { async } from 'regenerator-runtime';
import { API_URL, RES_PER_PAGE, API_KEY } from './config.js'
// import { getJson, sendJson } from './helpers.js'
import { AJAX } from './helpers.js'

export const state = {
    recipe: {},
    search: {
        query: ``,
        results: [],
        page: 1,
        resultsPerPage: RES_PER_PAGE
    },
    bookmarks: [],
};


const createRecipeObject = function (data) {
    const { recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...(recipe.key && { key: recipe.key })  //if recipe.key exist, 2nd part will be executed or else nothing will happen
    }
}

//this fucntion willnot return anything, itll only change the state object and controller will take the recipe object from state object
export const loadRecipe = async function (id) {
    try {
        const data = await AJAX(`${API_URL}/${id}?key=${API_KEY}`) //will recieve resolved promise
        state.recipe = createRecipeObject(data);

        if (state.bookmarks.some(bookmark => bookmark.id === id)) {
            state.recipe.bookmarked = true;
        } else {
            state.recipe.bookmarked = false;
        }

    } catch (err) {
        //temp error handling 
        console.error(`${err} error from model.js file`);
        throw err;
    }
}

export const loadSearchResults = async function (query) {
    try {
        state.search.query = query
        const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`)

        state.search.results = data.data.recipes.map(recipe => {
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...(recipe.key && { key: recipe.key })
            };

        }); state.search.page = 1;

    }
    catch (err) {
        console.error(`${err} error , cannot load search result`);
        throw err;
    }
};

export const getSearchResultPage = function (page = 1) {
    state.search.page = page;
    const start = (page - 1) * state.search.resultsPerPage;
    const end = (page * state.search.resultsPerPage);
    const paginationResult = state.search.results.slice(start, end);
    // console.log(paginationResult)
    return paginationResult;
}

export const updateServings = function (newServings) {


    state.recipe.ingredients.forEach(ing => {
        if (ing.quantity === null) return;

        ing.quantity = ing.quantity / state.recipe.servings * newServings;
    })
    state.recipe.servings = newServings;
}

const persistBookmarks = function () {
    localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks))
}

export const addBookmark = function (recipe) {
    //Add Bookmark
    state.bookmarks.push(recipe)

    //Mark cur rec as bookmark
    if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;

    persistBookmarks();
}

export const deleteBookmark = function (id) {
    //Delete BookMark
    const index = state.bookmarks.findIndex(el => el.id === id)
    state.bookmarks.splice(index, 1)
    //Mark cur rec as Not a  bookmark
    if (id === state.recipe.id) state.recipe.bookmarked = false;

    persistBookmarks();
}


const init = function () {
    const storage = localStorage.getItem('bookmarks')
    if (storage) state.bookmarks = JSON.parse(storage);
    console.log(state.bookmarks)
}
init();

export const uploadRecipe = async function (newRecipe) {
    //take raw data and convert it into same as that what we get from API
    try {
        console.log(Object.entries(newRecipe))
        const ingredients = Object.entries(newRecipe).filter(entry => entry[0].startsWith("ingredient") && entry[1] !== "")
            .map(ing => {
                const ingArr = ing[1].split(',').map(el => el.trim());
                // const ingArr = ing[1].replaceAll(' ', '').split(',');
                if (ingArr.length !== 3) throw new Error('Wrong ingredient format! Please use the correct format');

                const [quantity, unit, description] = ingArr;
                return { quantity: quantity ? +quantity : null, unit, description }
            });


        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients,
        }
        const data = await AJAX(`${API_URL}?key=${API_KEY}`, recipe)
        state.recipe = createRecipeObject(data)
        addBookmark(state.recipe)
    }
    catch (err) {
        throw err;
    }

}